// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'  //路由
import ElementUI from 'element-ui'  //引入element框架
import 'element-ui/lib/theme-chalk/index.css'
import * as api from './util/unit/api.js'  //api接口
import commin from './util/mixin/commin.js'  //图片拼接地址
import md5 from 'js-md5'  //md5加密
import axios from 'axios'
import './util/rem'
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo);

Vue.use(ElementUI)
Vue.prototype.$api=api
Vue.mixin(commin)
Vue.prototype.$md5=md5
Vue.prototype.$http=axios


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    
    document.dispatchEvent(new Event('render-event'))
    }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js